/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { InputAdornment } from "@mui/material";
import { ChangeEvent, HTMLInputTypeAttribute, ReactNode } from "react";
import { Controller } from "react-hook-form";
import { Control } from "react-hook-form/dist/types/form";
import { Path } from "react-hook-form/dist/types/path";
import { FieldValues } from "react-hook-form/dist/types/fields";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form/dist/types";

// components
import FormField, { FormFieldProps } from "./FormField";
import { Adornments } from "./adornments";

type InputBase = Omit<FormFieldProps, "type"> & {
  verify?: boolean;
  password?: boolean;
  fieldType?: HTMLInputTypeAttribute;
  inputBgColor?: string;
  adornment?: {
    position: "start" | "end";
    component: ReactNode;
  };
  // startAdornment?: ReactNode;
};

interface InputYupType<TFieldValues extends FieldValues = FieldValues>
  extends Omit<InputBase, "onChange"> {
  onChange?: (
    ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field?: ControllerRenderProps<TFieldValues, Path<TFieldValues>>
  ) => void;
  fieldName: Path<TFieldValues>;
  fieldControl: Control<TFieldValues, any>;
}

interface IFormTextField<TFieldValues extends FieldValues = FieldValues>
  // eslint-disable-next-line prettier/prettier
  extends InputYupType<TFieldValues> { }

const createAdornment = (
  adornment?: {
    position: "start" | "end";
    component: ReactNode;
  },
  verify?: boolean,
  fieldState?: ControllerFieldState,
  password?: boolean
) => {
  if (adornment) {
    if (adornment.position === "start")
      return {
        InputProps: {
          startAdornment: (
            <InputAdornment position={adornment.position}>{adornment.component}</InputAdornment>
          )
        }
      };
    if (!verify && adornment.position === "end")
      return {
        InputProps: {
          endAdornment: (
            <InputAdornment position={adornment.position}>{adornment.component}</InputAdornment>
          )
        }
      };
  }
  if (verify && !password)
    return {
      InputProps: {
        endAdornment: (
          <Adornments
            type="verify"
            position="end"
            correct={!fieldState?.invalid && fieldState?.isTouched}
          />
        )
      }
    };
  if (password)
    return {
      InputProps: {
        endAdornment: (
          <Adornments
            position="end"
            type="verify-password"
            correct={!fieldState?.invalid && fieldState?.isTouched}
          />
        )
      }
    };
};

export default function FormTextFieldController<
  TFieldValues extends FieldValues = FieldValues
>({
  verify,
  fieldName,
  fieldType,
  adornment,
  fieldControl,
  ...props
}: IFormTextField<TFieldValues>) {
  const formTextProps = (
    adornment?: {
      position: "start" | "end";
      component: ReactNode;
    },
    verify?: boolean,
    fieldState?: ControllerFieldState
  ) =>
    Object.assign(
      props,
      createAdornment(adornment, verify, fieldState, fieldType === "password")
    );

  return (
    <Controller
      control={fieldControl}
      name={fieldName}
      render={({ field, fieldState }) => {
        return (
          <FormField
            type={fieldType}
            onChange={ev => {
              if (!props?.disabled) {
                props?.onChange?.(ev, field);
                field.onChange(ev);
              }
            }}
            onBlur={field.onBlur}
            name={field.name}
            value={field.value}
            ref={field.ref}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            {...formTextProps(adornment, verify, fieldState)}
          />
        );
      }}
    />
  );
}
